import { Injectable, OnInit } from '@angular/core';
import { ParseDataService } from 'src/app/modules/product/services/parseData.service';
import { Product } from '../../models/product.model';
import { DataService } from '../../services/data.service';
import { CommonFunction } from './common.function';
import { Constant } from 'src/app/core/constant';
import { DateUtil } from 'src/app/shared/util/date.util';
declare let $: any;

@Injectable({ providedIn: 'any' })
export abstract class CreateProduct implements OnInit {
  product: Product;
  resource: any = {};
  type: any;
  tab: any;
  Constant = Constant;
  isSave = false;
  startDate = null;
  endDate = null;
  bank: any;
  isValidated: boolean = false;
  editForm: any;
  selectedDay: any;
  constructor(
    public dataService: DataService,
  ) {
  }
  ngOnInit(code?) {
    this.endDate = null;
    this.startDate = null;
    this.resource = this.dataService.getFull();
    this.product = new Product();
    this.type = code;
  }
  patchForm(field, value) {
    this.editForm.patchValue({
      [field]: value
    })
  }
  getResource() {}
  validate() {
    const error = $('.error-text');
    if (error && error.length > 0) {
      return false;
    }
    return true;
  }
  checkDateNull(code) {
    return DateUtil.checkDateNull(this[code]);
  }
  customScroll(value) {
    window.scrollTo(0, value);
  }
  save(isDraft?, func?) {
  }
  parseTime(time) {
    let hour: any = parseInt(time[0]);
    let po1 = 3;
    if (hour < 10) {
      hour = '0'  +  hour;
      po1 = 2;
    }
    if (hour > 23) {
      hour = '12';
    }
    return hour  +  ':'  +  time[1];
  }
  parsebeforeValidated() {
    this.isValidated = true;
    const keys = Object.keys(this.product);
    keys.forEach((key) => {
      if (typeof this.product[key] === 'string') {
        this.product[key] = this.product[key].trim();
      }
    });
  }
  changeCode(other?) {
    setTimeout(() => {
      other = other|| 'code';
      this.product[other] = CommonFunction.removeDiacritics(this.product[other].toUpperCase());
    }, 10);
  }
}
